module.exports = __webpack_public_path__ + "public/images/generated-dinosaurs.93c48fab86417fc3c333c4d9af43fbf2.jpg";